(function() {
  const triggerSelector = '[data-js-trigger="video"]';
  const volumeSelector = '.product-card-horizontal__volume';

  const videoCards = document.querySelectorAll(triggerSelector);

  Array.from(videoCards).forEach(videoCard => {
    if(!videoCard.listening) {
      videoCard.addEventListener('mouseover', playOnHover);
      videoCard.addEventListener('mouseout', stopOnBlur);
      videoCard.addEventListener('blur', stopOnBlur);

      videoCard.querySelector(volumeSelector)?.addEventListener('click', e => {
        e.stopPropagation();
        const video = videoCard.querySelector('video');
        if (video) {
          video.muted = !video.muted;
          e.currentTarget.classList.toggle('muted');
        }
      })
    }
    if(!videoCard.listening) videoCard.listening = true
  })


  document.addEventListener('touchstart', function(e) {
    const videoContainer = e.target?.closest(triggerSelector);
    if (!videoContainer) return stopAllCardVideos(videoCards);

    // allow unmute video
    if (e.target?.closest('.vjs-control-bar')) {
      return;
    }

    const video = videoContainer.querySelector('video');
    const isPlaying = isVideoPlaying(video);

    if (!isPlaying) {
      playOnHover.call(videoContainer);
    }
  })


  function stopVideo(videoEl) {
    videoEl.pause();
    videoEl.muted = true;
    videoEl.currentTime = 0;
  }

  function stopAllCardVideos(cards) {
    Array.from(cards).forEach(videoCard => {
      const videoContainer = videoCard.dataset.jsTrigger === 'video' ? videoCard : videoCard.querySelector('[data-js-triger="video"]');
      videoContainer?.classList.remove('active');
      videoCard.querySelector(volumeSelector)?.classList.add('muted')
      
      const video = videoCard.querySelector('video');
      if (video) stopVideo(video);
    });
  }

  function playOnHover() {
    const video = this.querySelector('video');
    if (!video) return;
    this.classList.add('active')
    if (!isVideoPlaying(video)) {
      stopAllCardVideos(videoCards);
    }

    video.play()
  }

  function stopOnBlur(e) {
    if (isSameCard(e)) return;
    console.log(e);

    const video = this.querySelector('video');
    if (video) stopVideo(video);
  }

  function isSameCard(e) {
    if (
      e.toElement?.classList.contains('product-card-horizontal__overlay')
      || e.toElement?.closest('.product-card-horizontal__overlay')
      || e.toElement?.closest('.product-card-horizontal__media-wrap')) {
      return true;
    }

    return false;
  }

  function isVideoPlaying(video) {
    return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)
  }
})();